/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

import { ANNUAL_PASS_IMAGE } from '../constants';

export const PassTypeProps = PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    summary: PropTypes.string,
    season: PropTypes.shape({
        start: PropTypes.string,
        end: PropTypes.string,
    }),
    cost: PropTypes.number,
    discount: PropTypes.number,
    transferable: PropTypes.bool,
    facility_restrictions: PropTypes.arrayOf(
        PropTypes.shape({
            facility_id: PropTypes.string,
            facility_type: PropTypes.string,
            facility_name: PropTypes.string,
            facility_url: PropTypes.string,
            restrictions: PropTypes.string,
        })
    ),
    fee_restrictions: PropTypes.string,
    owners: PropTypes.number,
});

export const PassTypeDefaults = {
    id: null,
    name: '',
    description: '',
    image_url: ANNUAL_PASS_IMAGE,
    summary: '',
    season: {
        start: '',
        end: '',
    },
    cost: 0, // divide by 1000 to get dollars and cents
    discount: 0, // divide by 1000 to get dollars and cents
    transferable: false,
    facility_restrictions: [],
    fee_restrictions: '',
    owners: 0,
};
